<template>
  <div>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-button
          variant="primary"
          @click="openModal(null, true, true)"
        >
          <feather-icon icon="PlusIcon" />
          Template WhatsApp
        </b-button>
      </b-col>
    </b-row>
    <!-- Criando o modal -->
    <b-modal
      ref="modalTemplate"
      size="lg"
      hide-footer
    >
      <modal-update-criate-template
        :template="template"
        :novo-template="novoTemplate"
        :show-dialog-id-input="showDialogIdInput"
        modal-update-criate-template
        @clear="clearCamposTemplate()"
        @templates="getTemplates()"
        @hide="$refs.modalTemplate.hide()"
        @create-template="createTemplate"
        @update-template="updateTemplate"
      /></b-modal>
    <!-- </b-modal> -->
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <b-row align-h="center">
            <b-col cols="8">
              <b-form-input
                v-model="tableTemplateWhatsApp.filter"
                type="search"
                placeholder="Pesquisar"
                class="mb-2"
                size="sm"
              />
            </b-col>
          </b-row>
          <b-table
            hover
            bordered
            striped
            responsive
            :filter="tableTemplateWhatsApp.filter"
            :current-page="tableTemplateWhatsApp.currentPage"
            :per-page="tableTemplateWhatsApp.perPage"
            :fields="tableTemplateWhatsApp.fields"
            :items="tableTemplateWhatsApp.items"
          >
            <template #cell(mensagem)="data">
              <!-- Sem a div vaiOUracha -->
              {{ data.item.mensagem }}
            </template>
            <template #cell(tipo_template)="data">
              <b-badge
                :variant="data.item.tipo_template === 'oficial' ? 'success' : 'primary'"
              >
                {{ data.item.tipo_template === 'oficial' ? 'Meta Oficial' : 'Padrão' }}
              </b-badge>
            </template>
            <template #cell(status)="data">
              {{ data.item.status ? 'Ativo' : 'Inativo' }}
            </template>
            <template #cell(modo_executivo)="data">
              {{ data.item.modo_executivo ? 'Ativo' : 'Inativo' }}
            </template>
            <template #cell(detalhes)="data">
              <!-- Ajustes na coluna de detalhes -->
              <b-row align-v="center">
                <b-col cols="auto">
                  <feather-icon
                    class="color-icon mr-1"
                    icon="EditIcon"

                    feather-icon
                    @click="editarTemplate(data.item)"
                  /></b-col>
                <b-col cols="auto">
                  <feather-icon
                    class="trash-icon"
                    icon="TrashIcon"
                    @click="deleteFornecedor(data.item)"
                  />
                </b-col>
              </b-row>
            </template>
          </b-table>
          <b-pagination
            v-model="tableTemplateWhatsApp.currentPage"
            :total-rows="tableTemplateWhatsApp.totalRows"
            :per-page="tableTemplateWhatsApp.perPage"
            align="center"
            size="sm"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import {
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  BPagination,
  VBModal,
  BModal,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import axios from '@/../axios-auth'
import modalUpdateCriateTemplate from './components/modalUpdateCriateTemplate.vue'

export default {
  components: {
    FeatherIcon,
    BRow,
    BCol,
    BButton,
    BCard,
    BModal,
    BTable,
    BPagination,
    BFormInput,
    BBadge,
    modalUpdateCriateTemplate,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      novoTemplate: true,
      showDialogIdInput: true,
      tableTemplateWhatsApp: {
        filter: '',
        fields: [
          'id',
          'titulo',
          'mensagem',
          { key: 'tipo_template', label: 'Tipo', class: 'text-center' },
          'status',
          { key: 'modo_executivo', label: 'Executivo', class: 'text-center' },
          { key: 'detalhes', label: 'ações', class: 'text-center' },
          { key: 'dialogo_id', label: 'Dialog ID' },
        ],
        items: [],
        totalRows: 1,
        perPage: 10,
        currentPage: 1,
      },
      template: {
        titulo: '',
        mensagem: '',
        status: true,
        modo_executivo: false,
        dialogo_id: null,
      },
    }
  },
  created() {
    this.getTemplates()
  },

  methods: {
    clearCamposTemplate() {
      this.template = {
        titulo: '',
        mensagem: '',
        status: true,
        modo_executivo: false,
        dialogo_id: null,
      }
    },
    // eslint-disable-next-line no-unused-vars
    openModal(templateData, isNew, showDialogId = true) {
      if (templateData) {
        this.template = { ...templateData }
      } else {
        this.clearCamposTemplate()
      }
      this.showDialogIdInput = showDialogId // Corrigido: Define a visibilidade
      this.$refs.modalTemplate.show()
    },
    editarTemplate(item) {
      this.novoTemplate = false
      // Se for template oficial (Meta), mapear os campos de volta
      if (item.tipo_template === 'oficial') {
        const itemMapeado = {
          ...item,
          // Reverter o mapeamento para o modal funcionar corretamente
          nome: item.titulo || item.nome,
          conteudo: item.mensagem || item.conteudo,
        }
        this.openModal(itemMapeado, false, true)
      } else {
        this.openModal(item, false, true)
      }
    },
    async getTemplates() {
      this.tableTemplateWhatsApp.items = []

      try {
        // Buscar templates padrão (WhatsApp)
        const resWhatsapp = await axios.get('/api/v1/template_whatsapp/')
        const templatesWhatsapp = resWhatsapp.data.dados.map(payload => ({
          ...payload,
          dialogo_id: payload.dialogo_id || null,
          tipo_template: 'padrao', // Identificador do tipo
        }))

        // Buscar templates Meta (Oficial)
        const resMeta = await axios.get('/api/v1/template_meta/')
        const templatesMeta = resMeta.data.dados.map(payload => ({
          ...payload,
          // Mapear campos do template_meta para o formato esperado pela tabela
          titulo: payload.nome, // API Meta usa "nome" ao invés de "titulo"
          mensagem: payload.conteudo, // API Meta usa "conteudo" ao invés de "mensagem"
          dialogo_id: payload.dialogo_id || null,
          tipo_template: 'oficial', // Identificador do tipo
        }))

        // Mesclar ambos os tipos
        this.tableTemplateWhatsApp.items = [...templatesWhatsapp, ...templatesMeta]

        // Ordenar por data
        this.tableTemplateWhatsApp.items.sort((a, b) => {
          // eslint-disable-next-line no-nested-ternary
          const dateA = a.updated_at ? new Date(a.updated_at) : (a.created_at ? new Date(a.created_at) : null)
          // eslint-disable-next-line no-nested-ternary
          const dateB = b.updated_at ? new Date(b.updated_at) : (b.created_at ? new Date(b.created_at) : null)

          if (dateB && dateA) return dateB - dateA
          if (dateB && !dateA) return 1
          if (!dateB && dateA) return -1
          return 0
        })

        this.tableTemplateWhatsApp.totalRows = this.tableTemplateWhatsApp.items.length
      } catch (error) {
        this.$swal({
          title: 'Erro!',
          text: 'Erro ao carregar templates',
          icon: 'error',
        })
      }
    },
    deleteFornecedor(item) {
      this.$swal({
        title: 'Tem certeza?',
        text: `Deseja deletar o template ${item.id}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Determinar a rota baseada no tipo do template
          const apiRoute = item.tipo_template === 'oficial'
            ? `/api/v1/template_meta/delete/${item.id}`
            : `/api/v1/template_whatsapp/delete/${item.id}`

          axios.delete(apiRoute, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          })
            .then(res => {
              if (res.data) {
                this.$refs.modalTemplate.hide()
                this.getTemplates()
                this.$swal({
                  icon: 'success',
                  title: 'Deletado!',
                  text: 'Template WhatsApp deletado com sucesso!',
                  timer: 1500,
                  showConfirmButton: false,
                })
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  title: 'Erro!',
                  text: error.response.data.mensagem || 'Erro ao processar',
                  icon: 'error',
                })
              }
            })
        }
      })
    },
    createTemplate(templateData) {
      // Determinar a rota baseada na flag tipo_template
      const isOficial = templateData.tipo_template === 'oficial'

      const apiRoute = isOficial
        ? '/api/v1/template_meta/store'
        : '/api/v1/template_whatsapp/store'

      axios.post(apiRoute, templateData)
        .then(() => {
          this.getTemplates()
          this.$refs.modalTemplate.hide()
          this.$swal({
            icon: 'success',
            title: 'Criado!',
            text: 'Template criado com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(error => { // Tratamento de erro
          if (error.response) {
            // Verificar se é erro específico do template Meta
            const isMetaError = error.response.data.mensagem === 'Falha ao criar template na Meta'
              && error.response.data.dados
              && error.response.data.dados.includes('Código: 100')

            this.$swal({
              title: 'Erro!',
              text: isMetaError ? 'Erro ao criar template na Meta. Verifique o texto do template.' : (error.response.data.mensagem || 'Erro ao processar'),
              icon: 'error',
            })
          }
        })
    },

    updateTemplate(templateData) {
      // Determinar a rota baseada na flag tipo_template
      const isOficial = templateData.tipo_template === 'oficial'

      // NOTE: template_meta não possui endpoint de update. Removemos a chamada PUT
      // para o recurso oficial e, quando for um template 'oficial' (Meta), faremos
      // um POST para o endpoint de store (criação) em vez de um update.
      if (isOficial) {
        const apiRoute = '/api/v1/template_meta/store'
        axios.post(apiRoute, templateData)
          .then(() => {
            this.getTemplates()
            this.$refs.modalTemplate.hide()
            this.$swal({
              icon: 'success',
              title: 'Atualizado!',
              text: 'Template atualizado com sucesso!',
              timer: 1500,
              showConfirmButton: false,
            })
          })
          .catch(error => { // Tratamento de erro
            if (error.response) {
              // Verificar se é erro específico do template Meta
              const isMetaError = error.response.data.mensagem === 'Falha ao criar template na Meta'
                && error.response.data.dados
                && error.response.data.dados.includes('Código: 100')

              this.$swal({
                title: 'Erro!',
                text: isMetaError ? 'Erro ao criar template na Meta. Verifique o texto do template.' : (error.response.data.mensagem || 'Erro ao processar'),
                icon: 'error',
              })
            }
          })
      } else {
        const apiRoute = `/api/v1/template_whatsapp/update/${templateData.id}`
        axios.put(apiRoute, templateData)
          .then(() => {
            this.getTemplates()
            this.$refs.modalTemplate.hide()
            this.$swal({
              icon: 'success',
              title: 'Atualizado!',
              text: 'Template atualizado com sucesso!',
              timer: 1500,
              showConfirmButton: false,
            })
          })
          .catch(error => { // Tratamento de erro
            if (error.response) {
              this.$swal({
                title: 'Erro!',
                text: error.response.data.mensagem || 'Erro ao processar',
                icon: 'error',
              })
            }
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.vaiOUracha{
  width: 50vw;
  height: 100px;
  overflow-y: auto;
  -webkit-border-horizontal-spacing: 10px;
}
.vaiOUracha::-webkit-scrollbar {
  width: 6px;
}
.vaiOUracha::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
